import { render, staticRenderFns } from "./OrganizationVariableCreate.vue?vue&type=template&id=107ceffc&"
import script from "./OrganizationVariableCreate.vue?vue&type=script&lang=js&"
export * from "./OrganizationVariableCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports